'use client';

import { Card, CardContent } from '@repo/ui';
import { CheckCircle } from 'lucide-react';
import type * as React from 'react';

export function SuccessCard(): React.ReactNode {
  return (
    <Card className="w-full max-w-sm">
      <CardContent className="flex flex-col items-center gap-3 pt-6">
        <CheckCircle className="size-8 text-green-500" />
        <p className="font-medium">Account connected!</p>
        <p className="text-sm text-muted-foreground text-center">
          You can now close this page and return to Telegram.
        </p>
      </CardContent>
    </Card>
  );
}
